import styled from "styled-components";
import images from "../../data/images";

export const HeaderComponent = styled.header`
background: url(${images.headerBg}) no-repeat center / cover; 
height: 100vh;
`;